import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Centered image-loading spinner that only appears after a grace delay, so a
 * fast load (cache hit, warm connection) completes with NO spinner frame at
 * all instead of blinking one for an instant.
 */
export function DelayedSpinner({ delayMs = 250 }: { delayMs?: number }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setShow(true), delayMs);
    return () => window.clearTimeout(t);
  }, [delayMs]);
  if (!show) return null;
  return (
    <span className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <Loader2 className="size-6 animate-spin text-muted-foreground" aria-hidden />
    </span>
  );
}
